import * as React from "react";

const MOBILE_BREAKPOINT = 768;

/**
 * Anchura fiable del lienzo. `window.innerWidth` cambia al hacer pinch-zoom en
 * Safari/iOS y hacía que el menú creyese estar en escritorio; `clientWidth` del
 * documento no se ve afectado por el zoom del visor.
 */
const readWidth = () =>
  document.documentElement?.clientWidth || window.innerWidth || 0;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    let frame = 0;

    const evaluate = () => {
      const width = readWidth();
      if (!width) return;
      setIsMobile((prev) => {
        // Histéresis de 24px: girar la pantalla o abrir el teclado no debe
        // hacer parpadear el menú justo en el límite.
        if (prev === true) return width < MOBILE_BREAKPOINT + 24;
        if (prev === false) return width < MOBILE_BREAKPOINT - 24;
        return width < MOBILE_BREAKPOINT;
      });
    };

    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(evaluate);
    };

    evaluate();

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    mql.addEventListener("change", schedule);
    window.addEventListener("resize", schedule);
    window.addEventListener("orientationchange", schedule);
    window.visualViewport?.addEventListener("resize", schedule);

    return () => {
      cancelAnimationFrame(frame);
      mql.removeEventListener("change", schedule);
      window.removeEventListener("resize", schedule);
      window.removeEventListener("orientationchange", schedule);
      window.visualViewport?.removeEventListener("resize", schedule);
    };
  }, []);

  return !!isMobile;
}
